import ShyListener from "./../modules/ShyListener";

document.addEventListener("DOMContentLoaded", () => {
  new ShyListener();
}, { once: true });
